import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";

export default function YachtSlider({ data = [] }) {
  const navigate = useNavigate();
  return (
    <Swiper
  modules={[Autoplay]}
  spaceBetween={20}
  slidesPerView={4}
  grabCursor={true}
  loop={true}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true, // ✅ THIS LINE
  }}
  breakpoints={{
    0: { slidesPerView: 1 },
    576: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 2 },
    1200: { slidesPerView: 3 },
    1300: { slidesPerView: 4 },
  }}
>

      {data.map((item, index) => (
      <SwiperSlide className="tour_swiper_slider" key={index}>
          <div className="tour-box">

            <div className="tour-box_img global-img">
              <img style={{ width: 312, height: 274, objectFit: "cover" }}
                alt="image" src={item.img} />
            </div>

            <div className="tour-content">
              <h3 className="box-title" style={{ color: "#000", fontWeight: "bold" }}>{item.title}</h3>

              <h4 className="tour-box_price">{item.desc}</h4>

              <div className="tour-action">
                <a
                  onClick={() => navigate(`/yachtdetails/${item.id}`)}
                  className="th-btn style4 th-icon"
                >
                  Book Now
                </a>
              </div>
            </div>

          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
